<template>
  <v-card>
    <v-progress-linear color="primary" :indeterminate="loading" height="3" />

    <v-card-title primary-title>
      <div class="headline">Notification</div>
    </v-card-title>

    <v-card-text>
      <v-text-field v-model="userId" label="User Id" />

      <v-btn @click="sendNotification">Send Notification</v-btn>
    </v-card-text>
  </v-card>
</template>

<script>
import sdk from "@/api/sdk/index";

export default {
  data() {
    return {
      userId: undefined,
      loading: false
    };
  },

  methods: {
    async sendNotification() {
      try {
        this.loading = true;

        const res = await sdk.request({
          method: "post",
          url: "/tests/notifications",
          data: {
            user_id: this.userId
          }
        });

        this.$notify.success(res.data.message);
      } finally {
        this.loading = false;
      }
    }
  }
};
</script>
